module.exports = __webpack_public_path__ + "static/media/16.a21ad8ca.mp3";